import React, { useState, useEffect, useContext } from 'react';
import marked from 'marked';

import Modal from '../../components/modal';
import { HTML } from '../../components/utils';
import LocaleContext from '../../contexts/locale';
import useBlockAnnouncement from '../../hooks/use-block-announcement';

import styles from './announcement.module.scss';

// dismissed per locale, so closing the german version
// still shows the english one after switching language
const storageKey = locale => `announcement-dismissed-${locale}`;

// sessionStorage can throw (e.g. blocked storage),
// so a failing read simply shows the announcement
const isDismissed = locale => {
  try {
    return window.sessionStorage.getItem(storageKey(locale)) === '1';
  } catch (e) {
    return false;
  }
};

const setDismissed = locale => {
  try {
    window.sessionStorage.setItem(storageKey(locale), '1');
  } catch (e) {
    /* noop */
  }
};

const Announcement = () => {
  const { title, intro, image, html, button_text, button_link } =
    useBlockAnnouncement() || {};
  const { currentLocale } = useContext(LocaleContext);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // client only: avoids rendering the modal into the static html
    setIsOpen(!isDismissed(currentLocale));
  }, [currentLocale]);

  if (!isOpen || !title) {
    return null;
  }

  const onDismiss = () => setDismissed(currentLocale);

  const onClose = () => {
    onDismiss();
    setIsOpen(false);
  };

  return (
    <Modal title={title} onClose={onClose} showFooter={false}>
      <div className={styles.text}>
        <HTML content={marked(intro)} />
        <img src={image.publicURL} alt="eventation | Alpin Convention" className={styles.banner} />
        <HTML content={html} />
      </div>

      <a
        href={button_link}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.button}
        onClick={onDismiss}>
        {button_text}
      </a>
    </Modal>
  );
};

export default Announcement;
